// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6e3d4db2","239":"29bbf57f","453":"b2965c0d","732":"75c4df5b"}[chunkId] + ".chunk.js";
};